export default "__VITE_ASSET__F8$Nuu9H__"